import { auth } from '../auth/firebase';
import { GoogleAuthProvider, signInWithCredential } from 'firebase/auth';
import { setJwtToken } from './auth.util';
import { isVitalyImplementation } from 'src/lib/utils/vitaly.util';

export const sendTokenToWebkit = (token: string) => {
  const isVitalyUser = isVitalyImplementation();
  if (window.webkit?.messageHandlers && !isVitalyUser) {
    window?.webkit?.messageHandlers?.sendToken?.postMessage(token);
  }
};

export const removeTokenFromWebkit = () => {
  const isVitalyUser = isVitalyImplementation();
  if (window.webkit?.messageHandlers && !isVitalyUser) {
    window?.webkit?.messageHandlers?.removeToken?.postMessage(null);
  }
};

export const isIOS = () => {
  return typeof window !== 'undefined' && window.webkit !== undefined;
};

export const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const setupGoogleSignInHandlerForIos = async () => {
  if (isIOS()) {
    // ts-ignore
    const handleUserReady = async (event: any) => {
      const tokenFromIOS = event.detail.token;
      try {
        const credential = GoogleAuthProvider.credential(tokenFromIOS);
        const firebaseUser = await signInWithCredential(auth, credential);
        const token = await firebaseUser.user.getIdToken();

        setJwtToken(token);
      } catch (error: any) {
        console.error(`Error logging in: ${error.code} ${error.message} token: ${tokenFromIOS}`, error);
      }
    };

    window.addEventListener('iosGoogleUserReady', handleUserReady);

    // Retornamos la función de cleanup específica para iOS
    return () => {
      window.removeEventListener('iosGoogleUserReady', handleUserReady);
    };
  }
};
